import React, { useEffect, useState } from 'react';
import {
  BasicIconButton,
  Button,
  CustomPopover,
  DocPreview,
  Modal,
} from 'components';
import IconView from 'components/BasicIconButton';
import Profile from 'pages/addprofile/Profile';
import {
  ProfileContainer,
  ProfileWaterMark,
  ProfileMenuListContainer,
} from '../../components/Common.style';

import { ReactComponent as ProfileImg } from 'assert/images/Common/profileImg.svg';
import { ReactComponent as AddPhoto } from 'assert/images/Profile/addPhoto.svg';
import { ReactComponent as More } from 'assert/images/Home/moreHorizantal.svg';
import { ReactComponent as Leftarrow } from 'assert/images/Common/arrowForward.svg';
import { ReactComponent as ShareIcon } from 'assert/images/Home/share.svg';
import { ReactComponent as EditOutlined } from 'assert/images/Profile/edit.svg';
import { ReactComponent as Mute } from 'assert/images/More/mute.svg';
import { ReactComponent as UnMute } from 'assert/images/More/unmute.svg';
import { ReactComponent as Block } from 'assert/images/More/block.svg';
import { ReactComponent as Mail } from 'assert/images/Profile/mail.svg';
import { ReactComponent as Report } from 'assert/images/More/report.svg';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ShareModal from 'pages/home/ShareModal';
import { t } from 'i18next';
import clsx from 'clsx';
import { Image } from 'antd';
import {
  changePostRelations,
  getPostRelationReq,
} from 'redux/features/ActivityPostSlice';
import DynModel from 'components/Modal';
import useWindowDimensions from 'components/Dimention';
import { getFileName, getFileType, swipeModalWidth } from 'utils/helper';
import SwipeableEdgeDrawer from 'components/SwipeableDrawer';
import { handleGetHighlightedResumeByUsername } from 'redux/features/UserResumeSlice';
import { UploadResumeContainer } from './Profiles.style';
import { Capacitor } from '@capacitor/core';
import { Share as ShareCapacitor } from '@capacitor/share';
import { ShareBaseUrl } from 'environment';
import ReportModal from 'components/ReportModal';

const ProfileContent = ({
  profileImages,
  showEdit,
  companyData,
  updateDetails,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;
  const isNative = Capacitor.isNativePlatform();

  const { currentProfile } = useSelector((state) => state?.ProfileSlice);
  const { getProfile } = useSelector((state) => state?.ProfileSlice);
  const { relationStates } = useSelector((state) => state.PostActivitySlice);

  const [loading, setLoading] = useState(false);
  const [resumeOpen, setResumeOpen] = useState(null);
  const [resumePath, setResumePath] = useState(false);
  const [typeInfo, setTypeInfo] = useState(null);
  const [shareOpen, setShareOpen] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const [openConfirmModel, setOpenConfirmModel] = useState(null);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);

  const relationDependency = JSON.stringify(relationStates || {});

  const getContent = () => {
    return (
      <Profile
        onClose={() => setTypeInfo(null)}
        typeInfo={typeInfo}
        profileImages={profileImages}
      />
    );
  };

  useEffect(() => {
    dispatch(handleGetHighlightedResumeByUsername(currentProfile?.username))
      .then((res) => {
        setResumePath(res?.data?.data?.[0]?.resume);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (relationDependency) {
      setLoading(false);
    }
  }, [relationDependency]);

  useEffect(() => {
    if (!showEdit && getProfile?.userId && currentProfile?.userId) {
      setLoading(true);
      dispatch(
        getPostRelationReq({
          userId: getProfile?.userId,
          followerId: currentProfile?.userId,
        })
      );
    }
  }, [getProfile, currentProfile]);

  const handleRelation = (key) => {
    setLoading(true);
    let payload = {
      userId: getProfile?.userId,
      followerId: currentProfile?.userId,
      key,
    };
    switch (key) {
      case 'FOLLOW':
      case 'UNFOLLOW':
      case 'WITHDRAW':
        payload = {
          ...payload,
        };
        break;
      case 'MUTE':
        payload = {
          ...payload,
          mute: !relationStates.isMuted,
        };
        break;
      case 'BLOCK':
        payload = {
          ...payload,
          block: !relationStates.isBlocked,
        };
        break;
      default:
        break;
    }
    dispatch(changePostRelations(payload, 'callGet'));
    setOpenConfirmModel(null);
    setOpenPopover(false);
    setLoading(false);
  };

  const profileMenuList = () => {
    return (
      <ProfileMenuListContainer>
        {showEdit ? (
          <>
            <div
              className="profile-item"
              onClick={() => navigate('/home/post')}
            >
              <div>{t(`profile.HomeActivity`)}</div>
              <Leftarrow />
            </div>
            <div
              className="profile-item"
              onClick={() => navigate('/jobs/applied-status')}
            >
              <div>{t(`profile.JobActivity`)}</div>
              <Leftarrow />
            </div>
            <div
              className="profile-item"
              onClick={() => navigate('/profile/business-hub')}
            >
              <div>{t('profile.BusinessPage')}</div>
              <Leftarrow />
            </div>
          </>
        ) : (
          <>
            <div
              className="other-profile-item profile-mute"
              onClick={() => (loading ? {} : handleRelation('MUTE'))}
            >
              {relationStates?.isMuted ? <UnMute /> : <Mute />}
              <div>
                {relationStates?.isMuted
                  ? t('HomePage.UnMute')
                  : t('HomePage.Mute')}{' '}
                @{currentProfile?.username}
              </div>
            </div>
            <div
              className="other-profile-item"
              onClick={() => (loading ? {} : handleRelation('BLOCK'))}
            >
              <Block />
              <div>
                {relationStates?.isBlocked
                  ? t('HomePage.UnBlock')
                  : t('HomePage.Block')}{' '}
                @{currentProfile?.username}
              </div>
            </div>
          </>
        )}
        <div
          className="common-profile-item"
          onClick={() => {
            if (isNative) {
              ShareCapacitor.share({
                title: currentProfile?.username,
                text: `${currentProfile.displayName} · ${currentProfile?.username}\n`,
                url: `${ShareBaseUrl}/profile/${currentProfile?.username}`,
                dialogTitle: 'Share with...',
              });
            } else {
              setShareOpen(true);
            }
          }}
        >
          <ShareIcon />
          <div>{t(`profile.ShareProfile`)}</div>
        </div>
        {!showEdit && (
          <div
            onClick={() => {
              setIsReportModalOpen(true);
              setOpenPopover(false);
            }}
            className="common-profile-item common-profile-item-report"
          >
            <Report />
            <div>{t('BusinessPlace.Report')}</div>
          </div>
        )}
      </ProfileMenuListContainer>
    );
  };

  const docPreviewContent = () => {
    return (
      <UploadResumeContainer>
        {getFileType(resumePath) === 'pdf' ? (
          <DocPreview src={resumePath} readOnly isScroll isScrollDownload />
        ) : (
          <iframe
            title={getFileName(resumePath)}
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${resumePath}`}
            height="650px"
            width="100%"
            style={{ border: 'none' }}
          />
        )}
      </UploadResumeContainer>
    );
  };

  const handleManageResume = () => {
    if (getProfile?.userId === currentProfile?.userId) {
      navigate(`/resume/${getProfile?.username}`);
    } else {
      setResumeOpen(true);
    }
  };

  return (
    <ProfileContainer>
      <div className="profile-content">
        <div className="img-container">
          {profileImages?.coverImage ? (
            <img src={profileImages?.coverImage} className="sub-profile" />
          ) : (
            <ProfileWaterMark>
              {[...Array(8)].map((_, index) => {
                return (
                  <div key={index} className="watermark-text">
                    WafyNet
                  </div>
                );
              })}
            </ProfileWaterMark>
          )}
          {showEdit && (
            <div className="edit-icons">
              <IconView
                icon={<AddPhoto />}
                src={false}
                onClick={() => setTypeInfo('profile')}
                size="small"
              />
            </div>
          )}
        </div>
        <div className="profile-highlight-container">
          <div className="profile-info">
            {profileImages?.profileImage ? (
              <Image
                src={profileImages?.profileImage}
                className="sub-profile"
              />
            ) : (
              <ProfileImg className="sub-profile" />
            )}
            {showEdit && (
              <div className="edit-subprofile-icon">
                <IconView
                  icon={<AddPhoto />}
                  src={false}
                  onClick={() => setTypeInfo('subProfile')}
                  size="small"
                />
              </div>
            )}
          </div>
          <div className="profile-popover">
            {!showEdit && (
              <>
                <Button
                  component="a"
                  href={`mailto:${currentProfile?.userEmail}`}
                  className="profile-user-mail"
                  variant="outlined"
                  startIcon={<Mail />}
                  label={<span className="btn-label">Mail Me</span>}
                />
                <Button
                  loading={loading}
                  color={
                    !relationStates?.isRequested &&
                    relationStates?.isAccepted &&
                    !relationStates?.isRejected &&
                    !relationStates?.isBlocked
                      ? 'error'
                      : 'primary'
                  }
                  label={
                    relationStates?.isRequested
                      ? t('profile.Withdraw')
                      : relationStates?.isAccepted &&
                        !relationStates?.isRejected &&
                        !relationStates?.isBlocked
                      ? t('profile.Unfollow')
                      : t('profile.Follow')
                  }
                  onClick={() =>
                    relationStates?.isRequested
                      ? setOpenConfirmModel('WITHDRAW')
                      : relationStates?.isAccepted &&
                        !relationStates?.isRejected &&
                        !relationStates?.isBlocked
                      ? setOpenConfirmModel('UNFOLLOW')
                      : handleRelation('FOLLOW')
                  }
                  variant={'outlined'}
                  customStyles="profile-follow-btn"
                />
              </>
            )}
            <CustomPopover
              isOpen={openPopover}
              handlePopoverClick={() => {
                setOpenPopover(true);
              }}
              action={<BasicIconButton icon={<More />} size="small" />}
              content={profileMenuList()}
            />
          </div>
          <div className="profile-highlight">
            <div className="profile-user-container">
              <div
                className="profile-display-name"
                title={currentProfile?.displayName || currentProfile?.username}
              >
                {currentProfile?.displayName || currentProfile?.username}
              </div>
              <div className="profile-split-dot">·</div>
              <div
                className="profile-username"
                title={currentProfile?.username}
              >
                {' @' + currentProfile?.username}
              </div>
            </div>
            <div>
              {currentProfile?.accountType === 1 && companyData?.title}
              {currentProfile?.accountType === 0 && currentProfile?.headline}
            </div>
            <div className="profile-contact">
              {currentProfile?.accountType === 1 && companyData?.headQuarters}
              {currentProfile?.accountType === 0 && currentProfile?.country && (
                <div>
                  {currentProfile?.city + ', ' + currentProfile?.country}
                </div>
              )}
              {((currentProfile?.accountType === 1 &&
                companyData?.headQuarters) ||
                (currentProfile?.accountType === 0 &&
                  currentProfile?.country)) && (
                <div className="profile-split-dot">·</div>
              )}
              <div>{currentProfile?.userEmail}</div>
            </div>
            <div className="user-follow-container">
              <div className="user-follow-item">
                <div
                  className={clsx(
                    getProfile?.userId === currentProfile?.userId &&
                      'follow-action'
                  )}
                  onClick={
                    getProfile?.userId === currentProfile?.userId
                      ? () => navigate('/network/follower')
                      : () => {}
                  }
                >
                  {currentProfile?.followerCount} {t('profile.Followers')}
                </div>
                <div
                  className={clsx(
                    getProfile?.userId === currentProfile?.userId &&
                      'follow-action'
                  )}
                  onClick={
                    getProfile?.userId === currentProfile?.userId
                      ? () => navigate('/network/following')
                      : () => {}
                  }
                >
                  {currentProfile?.followingCount} {t('profile.Following')}
                </div>
              </div>
              {currentProfile?.accountType === 0 &&
                ((getProfile?.userId !== currentProfile?.userId &&
                  resumePath) ||
                  getProfile?.userId === currentProfile?.userId) && (
                  <div className="manage-resume" onClick={handleManageResume}>
                    <div>{t('profile.ResumeText')}</div>
                    {getProfile?.userId === currentProfile?.userId && (
                      <EditOutlined />
                    )}
                  </div>
                )}
            </div>
            {currentProfile?.accountType === 0 &&
              getProfile?.userId === currentProfile?.userId && (
                <BasicIconButton
                  className="profile-highlight-edit"
                  icon={<EditOutlined />}
                  onClick={updateDetails}
                  ariaLabel="edit-outlined"
                  size="small"
                />
              )}
          </div>
        </div>
      </div>
      <DynModel
        removeHeader
        modalchanges="network"
        handleCancelModal={() => setOpenConfirmModel(null)}
        openModal={openConfirmModel !== null}
        content={
          <div className="confirmModal">
            <>
              {relationStates?.isRequested ? (
                <div>
                  <div className="title">{t('Notification.Withdraw')}</div>
                  <div className="sub-title">
                    {t('Notification.WithdrawRequest')}
                  </div>
                </div>
              ) : (
                <div className="title">{t('Notification.UnfollowModal')}</div>
              )}
            </>
            <div>
              <Button
                label={t('profile.Cancel')}
                variant="text"
                onClick={() => setOpenConfirmModel(null)}
              />
              <Button
                label={t('profile.Yes')}
                color="error"
                onClick={() => handleRelation(openConfirmModel)}
              />
            </div>
          </div>
        }
      />

      {isSmallScreen && typeInfo === 'profile' ? (
        <SwipeableEdgeDrawer
          openDrawer={typeInfo !== null}
          handleCloseDrawer={() => setTypeInfo(null)}
        >
          {getContent()}
        </SwipeableEdgeDrawer>
      ) : (
        <Modal
          content={getContent()}
          modalchanges={'commonModal'}
          openModal={typeInfo !== null}
          modelTitle={t(
            typeInfo === 'profile'
              ? 'profile.CoverImage'
              : 'profile.ProfileImage'
          )}
          handleCancelModal={() => setTypeInfo(null)}
        />
      )}
      {isSmallScreen ? (
        <SwipeableEdgeDrawer
          title={resumeOpen && getFileName(resumePath)}
          openDrawer={resumeOpen}
          handleCloseDrawer={() => setResumeOpen(null)}
        >
          {resumeOpen && docPreviewContent()}
        </SwipeableEdgeDrawer>
      ) : (
        <Modal
          modelTitle={resumeOpen && getFileName(resumePath)}
          content={resumeOpen && docPreviewContent()}
          openModal={resumeOpen}
          modalchanges="uploadResumeModal"
          handleCancelModal={() => {
            setResumeOpen(null);
          }}
        />
      )}
      <Modal
        handleCancelModal={() => setShareOpen(false)}
        openModal={shareOpen}
        modalchanges={'share-modal'}
        modelTitle={t('HomePage.Share')}
        width={500}
        closable
        content={<ShareModal path={`/profile/${currentProfile?.username}`} />}
      />
      <ReportModal
        resourceType={'user'}
        resourceId={isReportModalOpen}
        handleCloseReportModal={(data) => {
          setIsReportModalOpen(false);
          if (data?.closePopover) {
            setOpenPopover(false);
          }
        }}
      />
    </ProfileContainer>
  );
};
export default ProfileContent;
